export var OPEN = {
    borderRadius: 0,
    border: 'none',
    height: 80,
    width: '100vw',
    opacity: 1,
    transition: '200ms opacity',
    overflow: 'hidden',
    position: 'fixed',
    zIndex: 2147483600,
    top: 0,
    left: 0,
    right: 0
};
